module.exports = __webpack_public_path__ + "img/zixun.c8bab8c5.svg";